/* eslint-disable new-cap */
/* eslint-disable camelcase */
import { Images } from '@abcya/abcya_phaser';
import Phaser from 'phaser';

export default class BonusTimer extends Phaser.GameObjects.Container {
  constructor(game, onTimeOut) {
    super(game, 80, 60);
    this.game = game;
    this.gameTime = 40;
    this.curTime = this.gameTime;
    this.onTimeOut = onTimeOut;

    this.background = Images.addImage(0, 0, 'clockBackground', this);
    this.background.setOrigin(.5);

    this.countText = this.game.add.bitmapText(0, -3, 'AlarmClock', this.curTime, 55);
    this.countText.setOrigin(.5);
    this.countText.tint = 0x57ff73;
    this.timer = this.game.time.addEvent({ delay: 1000, loop: true, callback: () => {this.eh_UpdateCounter();} });

    this.TogglePause(true);

    this.add(this.countText);
  }

  TogglePause(toggle) {
    this.timer.paused = toggle;
  }

  eh_UpdateCounter() {
    this.curTime--;
    if (this.curTime < 0) this.curTime = 0;
    this.countText.text = this.curTime;

    if (this.curTime <= 0) {
      this.timer.paused = true;
      if (this.onTimeOut !== null) this.onTimeOut();
    }
  }
}